export const TAG = 'PendingCorporateActions';
export const SHOWN_PENDING_CORPORATE_ACTIONS_ITEMS_DEFAULT = 5;
